<script setup lang="ts">
    import type { $Fetch } from "ofetch";
    import { useOrderStore } from "~/composables/store/order";

    const nuxtConfig = useRuntimeConfig();
    const orderStore = useOrderStore();

    await callOnce("orderStoreInit", () =>
        orderStore.initialize($fetch as $Fetch, {
            hostUrl: nuxtConfig.public.api_url,
            enableDeliveries: nuxtConfig.public.enable_deliveries,
        }),
    );

    onMounted(() => {
        orderStore.storeFetch = $fetch as $Fetch;
    });
</script>

<template>
    <div>
        <slot v-if="!orderStore.ready" name="loading" />
        <slot v-else-if="!orderStore.checkoutOpen" name="checkoutClosed" />
        <template v-else>
            <shared-alert :alert="orderStore.options.configuration.alert" />
            <checkout-form />
        </template>
    </div>
</template>

<style scoped>
    /* Add your styles here */
</style>
